import { render, staticRenderFns } from "./StoreSection.vue?vue&type=template&id=1cd010b9&scoped=true&"
import script from "./StoreSection.vue?vue&type=script&lang=js&"
export * from "./StoreSection.vue?vue&type=script&lang=js&"
import style0 from "./StoreSection.vue?vue&type=style&index=0&id=1cd010b9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd010b9",
  null
  
)

export default component.exports